module.exports = __webpack_public_path__ + "img/green_082.3f2e6687.png";